/// <reference types="react" />
import * as React from "react";
import { ITestResultTreeData } from "TestManagement/Scripts/Scenarios/Common/Common";
import { IViewContextData, ContributionSource } from "TestManagement/Scripts/TestReporting/TestTabExtension/Common";
import { AddWorkItemHelper, AddBugAndWorkItem } from "TestManagement/Scripts/Scenarios/TestTabExtension/Helpers/AddWorkItemHelper";
import LWP = require("VSS/LWP");
import { TestTabTelemetryService } from "TestManagement/Scripts/Scenarios/TestTabExtension/Telemetry";

export interface ILegacyBugDialogProps {
    dialogType: string;
    results: ITestResultTreeData[];
    viewContext: IViewContextData;
}

export class LegacyBugDialog extends React.Component<ILegacyBugDialogProps, {}> {
    constructor(props: ILegacyBugDialogProps) {
        super(props);
    }

    public render(): null {
        let workItemHelper: AddWorkItemHelper = new AddWorkItemHelper(this.props.viewContext);
        if (this.props.results && this.props.results.length > 0) {
            let telemetryFeature: string = null;
            if (this.props.dialogType === AddBugAndWorkItem.Create_Bug) {
                workItemHelper.openCreateBugWindow(this.props.results);
                telemetryFeature = TestTabTelemetryService.featureTestTab_CreateBugClicked;
            } else if (this.props.dialogType === AddBugAndWorkItem.Add_To_Existing_Bug) {
                workItemHelper.openAddToExistingBugWindow(this.props.results);
                telemetryFeature = TestTabTelemetryService.featureTestTab_AddBugToExistingClicked;
            } else if (this.props.dialogType === AddBugAndWorkItem.Add_Associated_WorkItem) {
                workItemHelper.onAssociateWorkItemClick(this.props.results);
                telemetryFeature = TestTabTelemetryService.featureTestTab_AddTestTaskLinkClicked;
            }
            if (telemetryFeature) {
                TestTabTelemetryService.getInstance().publishDetailsPaneEvent(
                    telemetryFeature,
                    this.props.viewContext,
                    TestTabTelemetryService.eventClicked,
                    {
                        results: this.props.results
                    }
                );
            }
        }
        return null;
    }
}

LWP.registerLWPComponent("legacyBugDialog", LegacyBugDialog);
